import { useTranslation } from "react-i18next";

import { Form } from "./form";

import PageHero from "../components/page-hero";
import Footer from "../components/footer/footer";
import { usePageMeta } from "src/utils/seo";

const WriteReview = () => {
  const { t } = useTranslation();

  usePageMeta({
    title: t("writeReview.title"),
    description: t("writeReview.subtitle"),
  });

  return (
    <div className="min-h-screen w-full flex flex-col justify-between bg-kj-dark text-kj-ink">
      <PageHero
        eyebrow={t("writeReview.eyebrow")}
        title={t("writeReview.title")}
        subtitle={t("writeReview.subtitle")}
      />
      <div className="max-w-[1526px] w-full h-full mx-auto flex flex-col gap-y-8 px-4 mt-10 sm:mt-14 mb-8">
        <Form />
      </div>
      <Footer />
    </div>
  );
};

export default WriteReview;
